
import { stateType } from "./plantModelType";
import { defineComponent, nextTick, onMounted, reactive, toRefs } from "vue";
import { Router, useRoute, useRouter } from "vue-router";
import { getPlantModelData } from "../../../../api/farmer";
import events from "@/utils/events";
import Throttle from "@/utils/throttle";
let throttle: Throttle;
let scrollThrottle: Throttle;
function stateData() {
  return {
    typeId: "",
    plantPage: 1,
    selectedModel: {},
    tempId: "",
    modelList: [],
    keyword: "",
  };
}
export default defineComponent({
  setup() {
    const route = useRoute();
    const router = useRouter();
    const state = reactive<stateType>(stateData());
    const { getPlantModelList } = useData(state, router);
    onMounted(() => {
      state.typeId = route.query.typeId as string;
      state.tempId = route.query.tempId as string;
      nextTick(() => {
        getPlantModelList();
      });
      throttle = new Throttle(500, () => {
        getPlantModelList();
      });
      scrollThrottle = new Throttle(500, () => {
        state.plantPage++;
        getPlantModelList();
      });
    });

    return {
      ...toRefs(state),
      ...useData(state, router),
    };
  },
});
const useData = (state: stateType, router: Router) => {
  const onClickItem = (item: any, index: number) => {
    const tempData: object = item;
    if (state.modelList[index]) {
      state.modelList.forEach((item: any) => {
        item.isSelect = false;
      });
      state.modelList[index].isSelect = true;
      state.selectedModel = tempData;
    }
  };
  const onConfirm = () => {
    events.emit("finished", state.selectedModel);
    router.go(-1);
  };
  const onLoad = () => {
    scrollThrottle.search(null);
  };
  const getPlantModelList = async () => {
    const res: any = await getPlantModelData({
      page: state.plantPage,
      pageSize: 10,
      typeId: state.typeId,
      name: state.keyword,
    });
    if (res.data.code == 0) {
      const tempList = res.data.data.records.map((item: any) => {
        item.isSelect = false;
        return item;
      });
      // 查看是否已有数据被选中
      let isSelectData = state.modelList.filter((item: any) => item.isSelect);
      // 默认选中第一条
      if (tempList.length > 0 && isSelectData.length === 0) {
        // 回填已经被选中的供应商
        if (state.tempId && +state.tempId !== -100) {
          let arr = tempList.filter((item: any) => {
            return +item.id === +state.tempId;
          });
          if (arr[0]) {
            arr[0].isSelect = true;
            state.selectedModel = arr[0];
          }
        } else {
          // 没有选择的情况下默认选中第一条
          if (tempList.length > 0) {
            tempList[0].isSelect = true;
            state.selectedModel = tempList[0];
          }
        }
      }
      state.modelList = state.modelList.concat(tempList);
    }
  };
  const onKeyChange = (e: any) => {
    state.plantPage = 1;
    state.modelList = [];
    throttle.search(null);
  };
  return {
    getPlantModelList,
    onLoad,
    onConfirm,
    onClickItem,
    onKeyChange,
  };
};
